import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UserFormData, Store } from "@/types";
import StoreAssignment from "./StoreAssignment";

interface UserFormFieldsProps {
  formData: UserFormData;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSelectChange: (name: string, value: string) => void;
  isEditing: boolean;
  stores?: Store[];
}

const UserFormFields: React.FC<UserFormFieldsProps> = ({
  formData,
  handleInputChange,
  handleSelectChange,
  isEditing,
  stores = [],
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="name">Nome*</Label>
        <Input
          id="name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          className="bg-gray-800 border-gray-700"
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="email">Email*</Label>
        <Input
          id="email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleInputChange}
          className="bg-gray-800 border-gray-700"
          required
          disabled={isEditing}
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="avatar">URL da Foto</Label>
        <Input
          id="avatar"
          name="avatar"
          value={formData.avatar}
          onChange={handleInputChange}
          className="bg-gray-800 border-gray-700"
          placeholder="https://example.com/avatar.jpg"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="role">Função*</Label>
        <Select
          value={formData.role}
          onValueChange={(value) => handleSelectChange("role", value)}
        >
          <SelectTrigger className="bg-gray-800 border-gray-700">
            <SelectValue placeholder="Seleccione a função" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="admin">Administrador</SelectItem>
            <SelectItem value="user">Cliente</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="points">Pontos</Label>
        <Input
          id="points"
          name="points"
          type="number"
          value={formData.points}
          onChange={handleInputChange}
          className="bg-gray-800 border-gray-700"
          min="0"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="status">Status</Label>
        <Select
          value={formData.status}
          onValueChange={(value) => handleSelectChange("status", value)}
        >
          <SelectTrigger className="bg-gray-800 border-gray-700">
            <SelectValue placeholder="Seleccione o estado" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="active">Activo</SelectItem>
            <SelectItem value="inactive">Inactivo</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="main-store">Loja Principal</Label>
        <Select
          value={formData.mainStoreId || ""}
          onValueChange={(value) => handleSelectChange("mainStoreId", value)}
        >
          <SelectTrigger className="bg-gray-800 border-gray-700">
            <SelectValue placeholder="Seleccione a loja principal" />
          </SelectTrigger>
          <SelectContent className="bg-brand-dark border-gray-700">
            {stores.map(store => (
              <SelectItem key={store.id} value={store.id}>{store.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="connectedAccount">ID da Conta DartsBeat</Label>
        <Input
          id="connectedAccount"
          name="connectedAccount"
          value={formData.connectedAccount}
          onChange={handleInputChange}
          className="bg-gray-800 border-gray-700"
          placeholder="ID da conta conectada"
        />
      </div>
      
      {isEditing && stores.length > 0 && (
        <div className="md:col-span-2 space-y-2 pt-2 border-t border-gray-700">
          <StoreAssignment 
            userId={formData.id || ''} 
            stores={stores}
          />
        </div>
      )}
    </div>
  );
};

export default UserFormFields;
